import { PixelsShortsAutoplayParam } from './shorts/types';
import { log } from './module/log';
import { shortAssetTags, getPageUrl } from './shorts/utils';
import { loadScript, loadStylesheet } from './utils/assetLoader';

const programmatic = (componentParams: Omit<PixelsShortsAutoplayParam, 'el'>, pixelsInjectTag: string) => {
  const pixelsInjectTagNode = document.querySelector(pixelsInjectTag) as HTMLElement;
  const container = document.createElement('div');
  container.style.width = '100%';
  container.style.height = '100%';
  container.classList.add('pixels-shorts');
  pixelsInjectTagNode.style.height = '600px';
  pixelsInjectTagNode.appendChild(container);
  window.pixelsShortsAutoplay({
    el: container,
    ...componentParams,
  });
};

export const shortsLoader = async (
  pixelsInjectTag: string,
  pubId: string,
  playlistId: string,
  videos: any[],
  player: string = 'pixels'
) => {
  log('pixels', 'init vertical video');
  const sspName = '';
  const baseParams = {
    url: getPageUrl(),
    organisation: pubId,
    player,
    playlistId,
    sspName,
  };

  const stylesheetLoader = loadStylesheet(window.top.document);
  const scriptLoader = loadScript(window.top.document);
  const assets = shortAssetTags(player).map(url => (/\.css/.test(url) ? stylesheetLoader(url) : scriptLoader(url)));
  await Promise.all(assets);
  programmatic(
    {
      ...baseParams,
      videos,
    },
    pixelsInjectTag
  );
};
